import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdInfo } from 'react-icons/md';
import styled, { useTheme } from 'styled-components/macro';

const InfoMsgWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background: rgba(242, 244, 246, 1);
  border-radius: 5px;
  border: 1px solid rgba(0, 27, 83, 0.05);
  padding: 12px 0px;
`;

const Paragraph = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: rgba(0, 27, 83, 0.6);
  margin: 0;
  max-width: 330px;
`;

export const EmptyWidget = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  return (
    <InfoMsgWrapper>
      <MdInfo color={colors.neutral[60]} size={20} />
      <Paragraph>{t('No data to show for the selected timeframe.')}</Paragraph>
    </InfoMsgWrapper>
  );
};
